module.exports = __webpack_public_path__ + "static/media/pingdom-logo-white.91262e97.svg";